import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { AnswerItemComponent } from './answer-item.component';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('gap12'));
export var AnswerDetailsComponent = function AnswerDetailsComponent(_ref) {
  var question = _ref.question,
      answers = _ref.answers,
      isSubmissionSubmitted = _ref.isSubmissionSubmitted,
      correctAnswerLabel = _ref.correctAnswerLabel;

  var hasIncorrectAnswers = function hasIncorrectAnswers() {
    return ((answers === null || answers === void 0 ? void 0 : answers.answers) || []).some(function (answerBlank) {
      var _answerBlank$value;

      var isEmpty = !(answerBlank !== null && answerBlank !== void 0 && answerBlank.value) || ((_answerBlank$value = answerBlank.value) === null || _answerBlank$value === void 0 ? void 0 : _answerBlank$value.text) === '';
      if (isEmpty && isSubmissionSubmitted) return true;

      if (!isEmpty) {
        var isCorrect = answerBlank.score !== undefined && answerBlank.score > 0;
        return !isCorrect;
      }

      return false;
    });
  };

  if (!hasIncorrectAnswers()) return null;
  return /*#__PURE__*/_jsxs(Space, {
    direction: "vertical",
    style: {
      width: '100%'
    },
    children: [/*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsx(StyledWrapper, {
      children: (question.answers || []).map(function (answer, index) {
        return /*#__PURE__*/_jsx(AnswerItemComponent, {
          index: question.index + index,
          correctAnswerLabel: correctAnswerLabel,
          description: answer.description
        }, answer.id.toString());
      })
    })]
  });
};